<template>
  <NavBar
    :active="activeMenyIndex"
    :filter="filterOpt"
    :items="suppliers"
    :mode.sync="mode"
    :types="types"
    unload
    @changeFilter="$emit('changeFilter')"
    @filterItems="filterByTypes">
    <template #list_item_count="{ item }">
      {{ counts[item.count_type] || 0 }}
    </template>
  </NavBar>
</template>

<script>
import NavBar from 'components/common/blocks/NavBar.vue'
import { storageMixin } from 'mixins'

export default {
  name: 'suppliersNavBar',
  mixins: [
    storageMixin
  ],
  data() {
    return {
      activeMenyIndex: 0,
      filterOpt: {},
      types: [
        {
          name: 'Suppliers.AllSuppliers',
          type: 'All',
          count_type: 'total',
          all: true,
        },
        { name: 'Suppliers.Tested',
          type: 'VERIFIED',
          count_type: 'accredited',
          class: 'pl-7',
        },
        { name: 'Suppliers.WithRating',
          type: 'WITH_RATING',
          count_type: 'withRating',
          class: 'pl-7',
        },
        {
          name: 'Suppliers.MyWinners',
          type: 'WINNER',
          count_type: 'winners',
          class: 'pl-7',
        },
      ]
    }
  },
  mounted() {
    this.$_getPropFromDBStorage('suppliers_menuType', 0)
      .then((menuType) => {
        if (menuType !== this.activeMenyIndex) {
          this.filterByTypes(this.types[menuType])
        }
      })
  },
  props: {
    suppliers: Array,
    mini: Boolean,
    filter: Object,
    counts: Object
  },
  computed: {
    mode: {
      get() {
        return this.mini
      },
      set(value) {
        this.$emit('update:mini', value)
      }
    },
  },
  methods: {
    filterByTypes(item) {
      const index = this.types.findIndex(i => i.type === item.type)
      if (index !== -1) {
        this.$_savePropToDBStorage('suppliers_menuType', index)
        this.activeMenyIndex = index
        this.$emit('changeFilter')
        this.$emit('filterByTypes', item )
      }
    },
  },
  components: {
    NavBar
  }
}
</script>
